<!-- <li *ngIf="listHistorial?.length" style="font-size: 1.3rem !important; color: white !important;"
class="sp-menu__item sp-menu__item--submenu has-submenu">
<button  (click)="hitoriclik()" class="sp-menu__link sp-menu__toggle nav-link" arial-controls="programas-recientes"
    data-toggle="collapse" aria-haspopup="true" data-spmenu-submenu-toggle="hover">
    <i style="padding-top: 5px; font-size:20px; padding-right:2px;"
        class="aside__icon fa-solid fa-clock-rotate-left"></i>
    <i style="padding-top: 5px; font-size:20px; padding-right:2px;"
        class="side-mini-custom fa-solid fa-clock-rotate-left"></i>
    <span class="side-mini-custom sp-menu__link-text text fw-extrabold text"> Programas
        recientes</span>
    <i class="fa-solid fa-chevron-right link-arrow"></i>
</button>
    <span class="sp-menu__arrow"></span> -->
    <ul  class="sp-menu__subnav submenu" style="height: 200px;">

        <ng-container *ngFor="let l of listHistorial">

      

            <li class="sp-menu__item sp-menu__item--submenu" style="    font-size: 1.5rem;
            font-weight: 700;
            color: #064579;
            margin: 0;
            padding: 0;
            margin-top: 26px;" aria-haspopup="true"
                data-ktmenu-submenu-toggle="hover">
                <a [attr.aria-label]="l.idForm" routerLink="/pageTabPanel"
                    class="sp-menu__link sp-menu__toggle" name="{{l.idForm}}">

                    <span (click)="generarPage(l,false)" class="sp-menu__link-text text"
                        [title]="'Abrir ' + l.name">
                        <font style="vertical-align: inherit;">
                            <font style="vertical-align: inherit;">{{ l.name | titlecase }}
                            </font>
                        </font>
                    </span>
                </a>

            </li>

        </ng-container>
    </ul>
